module.exports = __webpack_public_path__ + "img/zhAward-3.288ca273.png";